import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Landing from "./pages/Landing";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import Onboarding from "./pages/Onboarding";
import OnboardingComplete from "./pages/OnboardingComplete";
import About from "./pages/About";
import Article from "./pages/Article";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import ClientOpsPage from "./pages/ClientOpsPage";
import RentalsPage from "./pages/RentalsPage";
import RentalsSignupPage from "./pages/RentalsSignupPage";
import AdminVideosPage from "./pages/AdminVideosPage";
import EnrolFramePage from "./pages/EnrolFramePage";
import SoleTradersPage from "./pages/SoleTradersPage";
import CompaniesPage from "./pages/CompaniesPage";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.05,
      smoothWheel: true,
      wheelMultiplier: 1,
    });
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/about" element={<About />} />
          <Route path="/learn/:slug" element={<Article />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/clientops" element={<ClientOpsPage />} />
          <Route path="/rentals" element={<RentalsPage />} />
          <Route path="/rentals/signup" element={<RentalsSignupPage />} />
          <Route path="/admin/videos" element={<AdminVideosPage />} />
          <Route path="/enrol/:slug" element={<EnrolFramePage />} />
          <Route path="/sole-traders" element={<SoleTradersPage />} />
          <Route path="/companies" element={<CompaniesPage />} />
          <Route path="/checkout/success" element={<CheckoutSuccess />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/onboarding/complete" element={<OnboardingComplete />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
